import './App.css';
import {Routes, Route} from "react-router-dom";
import Home from './modules/Home/Home';
import Contact from './component/Contact/Contact';

function App() {
  return (
    <Routes>
      <Route path='/' exact element={<Home/>}/>
      <Route path='/#contact' exact element={<Contact/>}/>
      <Route path='*' exact element={<Home/>}/>
    </Routes>
  );
}

export default App;
